import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// Sticky mobile CTA bar for conversion optimization
const StickyCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isScrollingUp, setIsScrollingUp] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Show after scrolling 300px
      if (currentScrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }

      // Detect scroll direction
      setIsScrollingUp(currentScrollY < lastScrollY);
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  if (!isVisible) return null;

  return (
    <div 
      className={`fixed bottom-0 left-0 right-0 bg-green-600 text-white py-3 px-4 z-50 shadow-lg transform transition-transform duration-300 md:hidden ${
        isScrollingUp ? 'translate-y-0' : 'translate-y-full'
      }`}
      data-testid="sticky-cta"
    >
      <div className="flex items-center justify-between max-w-lg mx-auto">
        <a 
          href="tel:6462099955" 
          className="flex items-center justify-center bg-white text-green-600 px-4 py-2 rounded-lg font-bold text-sm flex-1 mr-2"
          data-testid="sticky-call-btn"
        >
          <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/>
          </svg>
          Call Now
        </a>
        <Link 
          to="/contact" 
          className="flex items-center justify-center bg-blue-600 text-white px-4 py-2 rounded-lg font-bold text-sm flex-1 ml-2"
          data-testid="sticky-quote-btn"
        >
          Free Quote
        </Link>
      </div>
    </div>
  );
};

export default StickyCTA;
